import React from 'react';

interface LogoProps {
    className?: string;
}

const logoUrl = `${import.meta.env.BASE_URL}logo.svg`;

const Logo: React.FC<LogoProps> = ({ className }) => (
    <img src={logoUrl} alt="" aria-hidden="true" width={64} height={64} className={className} />
);

export default Logo;
